import { useParams } from 'react-router-dom';

import { AssetType } from '../entities/asset-type';
import { GetStaticData } from '../queries/get-static-data';

import { useAssetsFilters } from './use-assets-filters';

export type AssetTypesExist = Record<AssetType, boolean>;

const disabledState: AssetTypesExist = {
  [AssetType.CONTAINER]: true,
  [AssetType.PCS]: false,
  [AssetType.STRING]: false,
  [AssetType.RACK]: false,
  [AssetType.MODULE]: false,
};

export function useAssetTypesExist(): AssetTypesExist {
  const { siteId } = useParams<{ siteId: string }>();
  const [assetsFilters] = useAssetsFilters();

  const staticData = GetStaticData.useQuery({
    siteId,
    date: assetsFilters.date,
  });

  if (staticData.isLoading) {
    return disabledState;
  }

  if (staticData.isError || !staticData.data) {
    return disabledState;
  }

  return {
    [AssetType.CONTAINER]: staticData.data.containers.length > 0,
    [AssetType.PCS]: (staticData.data.pcs?.length ?? 0) > 0,
    [AssetType.STRING]: staticData.data.containers.some(
      (container) => (container.rackStrings?.length ?? 0) > 0,
    ),
    [AssetType.RACK]: staticData.data.containers.some(
      (container) => (container.racks?.length ?? 0) > 0,
    ),
    [AssetType.MODULE]: staticData.data.containers.some(
      (container) => (container.modules?.length ?? 0) > 0,
    ),
  };
}
